var data = {
	"body": "<path d=\"M17.5 19.508V8.626h-4v10.88c-1.403.728-2.374 2.18-2.374 3.87a4.376 4.376 0 0 0 8.751.001c0-1.69-.97-3.142-2.376-3.868zm3-14.26c0-2.756-2.244-5-5-5s-5 2.245-5 5v12.727a7.313 7.313 0 0 0-2.375 5.4c0 4.066 3.31 7.377 7.376 7.377s7.375-3.31 7.375-7.377c0-2.086-.878-4.03-2.375-5.402V5.25zm.375 18.13A5.379 5.379 0 0 1 15.5 28.75a5.38 5.38 0 0 1-5.373-5.373c0-1.795.896-3.443 2.376-4.438V5.25c0-1.653 1.343-3 2.997-3s3 1.346 3 3v13.69a5.332 5.332 0 0 1 2.375 4.437zm1.21-14.752l4.5 2.598V6.03l-4.5 2.596z\" fill=\"currentColor\"/>",
	"width": 32,
	"height": 32
};
exports.__esModule = true;
exports.default = data;
